import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

export type FavoriteProductType = 'order' | 'route' | 'service' | 'complexProduct';

export interface FavoriteProduct {
  id: string;
  data: string;
  type: FavoriteProductType;
  userID: string;
}

export interface BitrixUser {
  id: string;
  transport_requests_per_month: number; // лимит запроса в месяц
  favourites: FavoriteProduct[]; // список избранных продуктов пользователя
  archive: FavoriteProduct[]; // список архивных расчетов
}

export interface LoadUserQueryResponse {
  BitrixUserProfile: BitrixUser;
}

/**
 * Запрос загрузки данных по валюте
 */
export class LoadBitrixUserQuery implements GraphQLQuery<null> {
  readonly query: any;

  readonly variables: null;

  constructor() {
    this.variables = null;
    this.query = gql`
      query __LOAD_USER__ {
        BitrixUserProfile {
          id
          transport_requests_per_month
          favourites {
            id
            data
            type
            userID
          }
          archive {
            id
            data
            type
            userID
          }
        }
      }
    `;
  }
}
